export default __webpack_public_path__ + "static/media/logo-us-brandy-melvilles.d6ee51a7.svg";